import { render, staticRenderFns } from "./CreatePolicyDialog.vue?vue&type=template&id=1029e447&"
import script from "./CreatePolicyDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePolicyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports